<template>
  <div class='h-outTabs'>
    <ejs-tab id='trackTaskTab' ref='tabRef' :showCloseButton='true' :removing='changeTab' :removed='removeTabFunc' :selecting='tabSelect' heightAdjustMode='Auto'>
      <e-tabitems>
        <e-tabitem :header='tab.headerText' content='#trackTable' cssClass='h-tab-noClose'></e-tabitem>
      </e-tabitems>
    </ejs-tab>
    <div id='trackTable' class='h100vh-140'>
      <ConfigTableMenu   ref="configTableMenu" @methodEnum='methodEnum' @keywords='changeKeywords'></ConfigTableMenu>
      <ConfigExTable :trackType='trackType' ref="configExTable" ></ConfigExTable>
    </div>
  </div>
</template>
<script>
import ConfigTableMenu from './ConfigTableMenu';
import ConfigExTable from './ConfigExTable';
import DownloadFile from './DownloadFile';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
// import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'TrackTaskList',
  components: {
    ConfigTableMenu,
    ConfigExTable
  },
  props: ['trackType'],
  data() {
    return {
      locale: localStorage.getItem('locale'),
      tab: {
        headerText: { text: this.$t('System.configMenu') }
      },
      tabList: [this.$t('Track.taskList')],
      tabListVallue: [this.$t('Track.taskList')]
    };
  },
  methods: {
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    changeKeywords(args) {
      console.log("--------",args)
      this.$refs.configExTable.queryConditions.keywords = args;
      this.$refs.configExTable.page.pageNo = "1";
      this.$refs.configExTable.getTrackListData();
    },

    downloadTab(args) {
      const title = this.$t('Track.download');
      const item = {
        header: { text: title },
        content() {
          return {
            template: DownloadFile
          };
        }
      };
      this.addTabFunc(title, item, args);
    },
    addTabFunc(title, item, args) {
      const tabObj = this.$refs.tabRef.ej2Instances;
      const itemLength = document.querySelectorAll('#trackTaskTab .e-tab-header .e-toolbar-item').length;
      const index = this.tabList.findIndex(v => v === title);
      if (index > 0) {
        tabObj.select(index);
      } else if (title !== this.$t('Track.download') && title.indexOf('.json') === -1) {
        const missionTab = this.tabList.filter(v => v !== this.$t('Track.download') && v.indexOf('.json') === -1);
        if (missionTab.length > 5) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.maximumMissionNumber')});
        } else {
          this.tabList.push(title);
          this.tabListVallue.push(args);
          tabObj.addTab([item], itemLength);
          tabObj.select(itemLength);
        }
      } else {
        this.tabList.push(title);
        this.tabListVallue.push(args);
        tabObj.addTab([item], itemLength);
        tabObj.select(itemLength);
      }
      bus.$emit(title, args);
    },
    removeTabFunc(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      bus.$off(this.tabList[index]);
      if (this.tabList[index] !== this.$t('Track.download') && this.tabList[index].indexOf('.json') === -1) {
        // 只有跟踪页面关闭websocket
        // socketInstance.stopReceiveTopicMsg(`track_${this.tabListVallue[index][0].taskId}`, '/user/#/TrackReportServer');
      }
      this.tabList.splice(index, 1);
      this.tabListVallue.splice(index, 1);
    },
    changeTab(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      const tabObj = this.$refs.tabRef.ej2Instances;
      const selecteIdndex = tabObj.selectedItem;
      const itemLength = document.querySelectorAll('#trackTaskTab .e-tab-header .e-toolbar-item').length;
      if (index == selecteIdndex) {
        if (index == (itemLength - 1)) {
          tabObj.select(itemLength - 2);
        } else {
          tabObj.select(itemLength - 1);
        }
      }
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          // this.$refs.trackTable.queryConditions.keywords = '';
          this.$refs.configExTable.page.pageNo = "1";
          this.$refs.configExTable.getTrackListData();
          break;
        case 'export':
          const rows = this.$refs.configExTable.getCheckedData(true);
          if(rows.length ===0){
            EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
            return;
          }
          this.$refs.configTableMenu.exportData(rows);
          break;
        case 'import':
          this.$refs.configTableMenu.addDialog();
          break;
        case 'refrush':
          this.$refs.configExTable.queryConditions.keywords = this.$refs.configTableMenu.queryConditions.keywords;
          this.$refs.configExTable.page.pageNo = "1";
          this.$refs.configExTable.getTrackListData();
          break;
        case 'restore':
          const selectRows = this.$refs.configExTable.getCheckedData(true);
          if(selectRows.length ===0){
            EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
            return;
          }
          this.$layer.confirm({
            msg: this.$t('MML.neCfgRestoreConfirmTip'),
            btn1: {
              msg: this.$t('Common.cancel'),
            },
            btn2: {
              msg: this.$t('Common.confirm'),
              func: () => {
                this.$refs.configTableMenu.neCfgRestore(selectRows);
              }
            }
          });
        default:
      }
    }
  },
  mounted() {
    bus.$on('downloadTableTab', (args) => {
      console.log(1, args);
      this.downloadTableTab(args);
    });
  },
  beforeDestroy() {
    bus.$off('downloadTableTab');
  }
};
</script>
